import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { DesignData } from "../../../services/index";
import { FormGroup, FormControl, Validators } from "@angular/forms";
declare var $: any;
@Component({
  selector: "design-upload",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "designUpload.html",
})
export class designUpload implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  design_no = "";
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = false;
  public imagePath: any;
  imgURL: any;
  public message: string;

  constructor(
    public store: Store<fromRootStore.State>,
    private designdata: DesignData
  ) {}
  hotkeys(event) {
    if (this.active) {
    }
  }

  ngOnInit(): void {}

  preview(files) {
    console.log(files);
    if (files.length === 0) return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      swal(this.message);
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    };
  }
  deleteFile() {
    if (this.design_no == "") {
      swal("Please Enter design no to delete");
    } else {
      let params = {
        design_no: this.design_no,
        do: "delete",
      };
      swal({
        title:
          "ARE SURE TO DELETE THIS DESIGN PHOTO (" + this.design_no + ") ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "YES, DELETE IT!",
        cancelButtonText: "NO",
      })
        .then(() => {
          let that = this;
          that.loadingIndicator = true;
          that.isLoadMask = that.designdata
            .deleteDesignAttachment(params)
            .then(function (res: any) {
              that.loadingIndicator = false;
              if (res.success) {
                that.design_no = "";
                that.message = "";
                that.imagePath = [];
                that.imgURL = "";
                swal("DESIGN PHOTO DELETED SUCCESSFULLY");
              }
              if (!res.success) {
                swal("SOMETHING WENT WRONG");
              }
            })
            .catch((res: any) => {
              swal(res.statusText);
            });
        })
        .catch((res: any) => {
          swal(res.statusText);
        });
    }
  }
  startUploading() {
    if (this.design_no == "" || this.imgURL == "") {
      swal("Please Enter design no (or) Make sure that Photo was selected");
    } else {
      let params = {
        design_no: this.design_no,
        data: this.imgURL,
      };
      console.log(params);
      let that = this;
      swal({
        title:
          "ARE YOU SURE TO UPLOAD THIS DESIGN PHOTO (" + this.design_no + ") ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "YES, UPLOAD IT!",
        cancelButtonText: "NO",
      })
        .then(() => {
          that.loadingIndicator = true;
          that.isLoadMask = that.designdata
            .uploadDesignPhoto(params)
            .then(function (res: any) {
              that.loadingIndicator = false;
              if (res.success) {
                that.design_no = "";
                that.message = "";
                that.imagePath = [];
                that.imgURL = "";

                swal("DESIGN PHOTO UPLOADED SUCCESSFULLY");
              }
              if (!res.success) {
                swal(res.message);
              }
            })
            .catch((res: any) => {
              swal(res.statusText);
            });
        })
        .catch((res: any) => {
          swal(res.statusText);
        });
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/designUpload/designUpload.ts